import React, { memo, useMemo } from "react";
import { ImageView } from "./image-view";

type TncProps = {};

export type ParagraphContentType = {
  // tag is character for numbering
  tag?: string;
  // content is Text on the right tag
  content: string;
  // subContent is Text below tag and content or above child
  subContent?: string;
  // subContent is Text below tag and content or above child after subContent
  subContent2?: string;
  // content2 is Text below child
  content2?: string;
  // content3 is Text below child after content2
  content3?: string;
  // contentNoFormat is Text bottom of component and don't have indent space
  contentNoFormat?: string;
  // contentNoFormat is Text bottom of component and don't have indent space after contentNoFormat
  contentNoFormat2?: string;
  // for image view
  image?: any;
  // image tag is Text below image
  imageTag?: string;
  // isBulletin is mean a list with bulletin and you should given null to tag
  isBulletin?: boolean;
  // isPercentContent is mean a list with percent style on TC agreement PK/PMK
  isPercentContent?: boolean;
  // child is children of this paragraph
  child?: ParagraphContentType[];
  // isTagNumber is mean a list with numbering short margin than normal tag
  isTagNumber?: boolean;
};

export enum TYPE_PARAGRAPH {
  PARAGRAPH = "PARAGRAPH",
  NUMBERING = "NUMBERING",
}

const RenderChildren = ({
  v,
  i,
  type,
}: {
  v: ParagraphContentType;
  i: number;
  type: TYPE_PARAGRAPH;
}) => {
  const { innerWidth } = window;
  const isParagraph = type === TYPE_PARAGRAPH.PARAGRAPH;
  const isNumbering = type === TYPE_PARAGRAPH.NUMBERING;
  const isBulletin = v?.isBulletin;

  const tagWidth = useMemo(() => {
    if (v?.isPercentContent) {
      return 80;
    }
    if (isNumbering) {
      return 20;
    }

    return 44;
  }, [type, v]);

  const calculateStyle = useMemo(() => {
    const tagWidthNormal = 44;
    const firstSecondChild = i - 1;
    const firstSecondChilds = i - 2;
    const marginLeftParagraph =
      i > 2 ? tagWidthNormal * firstSecondChild - tagWidthNormal * firstSecondChilds : 0;
    const marginLeftNumbering = i > 1 ? tagWidth * i - tagWidth : 0;
    const marginLeftPercentContent = 4;
    const calculateTagWidth = v?.isPercentContent
      ? tagWidthNormal * (firstSecondChild - 1) + tagWidth + marginLeftPercentContent
      : tagWidth * firstSecondChild;
    const width = i > 2 ? innerWidth - calculateTagWidth : innerWidth - tagWidthNormal;
    const widthBulletin = width - 12;

    return {
      marginLeft: isParagraph ? marginLeftParagraph : marginLeftNumbering,
      width: isBulletin ? widthBulletin + 10 : width + 10,
    };
  }, [i, tagWidth, isParagraph, v]);

  const isHasChild = !!v?.child?.length;

  const isFirstParent = i === 1 && isParagraph;
  const marginLeftNumber = 8;

  const widthTagStyle2 = isNumbering ? calculateStyle.width + tagWidth : calculateStyle.width;

  const fontParagraph = "text-xs text-justify text-[#666666] font-semibold";
  const fontHeader = `text-justify text-[#666666]   ${
    isFirstParent ? "text-sm " : "text-xs"
  } font-bold`;

  const contentPercent = `${fontParagraph} w-[${calculateStyle.width}] `;

  return (
    <div
      className={`${i === 1 && !isNumbering ? "mt-1.5" : "mt-0.5"}`}
      style={{ marginLeft: isNumbering ? calculateStyle.marginLeft + marginLeftNumber : calculateStyle.marginLeft }}>
      <div className="flex flex-row  ">
        {v?.isPercentContent ? (
          <div className={`flex flex-row justify-between  `} style={{ width: tagWidth + 25 }}>
            <p
              dangerouslySetInnerHTML={{ __html: v?.tag || "" }}
              className={`${fontParagraph} text-left  font-bold`}
            />

            <p className={fontParagraph}>:</p>
          </div>
        ) : (
          !isBulletin && (
            <div style={{ width: v?.isTagNumber ? tagWidth - 20 : tagWidth }}>
              <p dangerouslySetInnerHTML={{ __html: v?.tag || "" }} className={fontHeader} />
            </div>
          )
        )}

        {isBulletin ? (
          <div className="flex flex-row   ">
            <p
              className={`text-left text-[#666666] font-bold text-sm ml-[20px] w-[10px] -mt-[3px]`}>
              •
            </p>

            <p
              dangerouslySetInnerHTML={{ __html: v?.content }}
              className={`${!!v?.isPercentContent ? contentPercent : fontParagraph} ml-15`}
              style={{
                width: calculateStyle.width - tagWidth - 15 - marginLeftNumber * i,
              }}
            />
          </div>
        ) : (
          <p
            dangerouslySetInnerHTML={{ __html: v?.content || "" }}
            className={`${isFirstParent ? fontHeader : fontParagraph} ml-1`}
            style={{
              width: !!v?.isPercentContent ? calculateStyle.width : widthTagStyle2,
            }}
          />
        )}
      </div>
      {!!v?.subContent && (
        <p
          dangerouslySetInnerHTML={{ __html: v?.subContent || "" }}
          className={`${fontParagraph} mt-0.5`}
          style={{
            marginLeft: i > 2 ? calculateStyle.marginLeft : calculateStyle.marginLeft + tagWidth,
          }}
        />
      )}

      {!!v?.subContent2 && (
        <p
          dangerouslySetInnerHTML={{ __html: v?.subContent2 || "" }}
          className={`${fontParagraph} mt-0.5`}
          style={{
            marginLeft: i > 2 ? calculateStyle.marginLeft : calculateStyle.marginLeft + tagWidth,
          }}
        />
      )}
      {isHasChild &&
        v?.child?.map((child2: ParagraphContentType) => (
          <RenderChildren v={child2} i={i + 1} type={type} />
        ))}

      {!!v?.content2 && (
        <p
          dangerouslySetInnerHTML={{ __html: v?.content2 || "" }}
          className={`${fontParagraph}  `}
          style={{
            marginLeft: i > 2 ? calculateStyle.marginLeft : calculateStyle.marginLeft + tagWidth,
          }}
        />
      )}
      {!!v?.content3 && (
        <p
          dangerouslySetInnerHTML={{ __html: v?.content3 || "" }}
          className={`${fontParagraph}  `}
          style={{
            marginLeft: calculateStyle.marginLeft + tagWidth,
          }}
        />
      )}

      {!!v?.contentNoFormat && (
        <div
          className={`mt-0.5`}
          style={{
            marginLeft:
              isNumbering && i === 1
                ? calculateStyle.marginLeft
                : calculateStyle.marginLeft - tagWidth,
          }}>
          <p
            dangerouslySetInnerHTML={{ __html: v?.contentNoFormat || "" }}
            className={`${fontParagraph}`}
          />
        </div>
      )}
      {!!v?.contentNoFormat2 && (
        <div
          className={`mt-0.5`}
          style={{
            marginLeft:
              isNumbering && i === 1
                ? calculateStyle.marginLeft
                : calculateStyle.marginLeft - tagWidth,
          }}>
          <p
            dangerouslySetInnerHTML={{ __html: v?.contentNoFormat2 || "" }}
            className={`${fontParagraph}  `}
          />
        </div>
      )}

      {!!v?.image && (
        <div className={`mt-1 ml-[${calculateStyle.marginLeft}px]  `}>
          <ImageView src={v?.image} alt="img_1" />

          <p
            dangerouslySetInnerHTML={{ __html: v?.imageTag || "" }}
            className={`text-xs text-center text-[#666666] font-semibold`}
          />
        </div>
      )}
    </div>
  );
};

export const ParagraphTnc = ({
  content,
  type = TYPE_PARAGRAPH.PARAGRAPH,
}: {
  content: ParagraphContentType[];
  type?: TYPE_PARAGRAPH;
}) => (
  <div className="flex flex-col">
    {content?.map((v: ParagraphContentType) => (
      <RenderChildren v={v} i={1} type={type} />
    ))}
  </div>
);
